import React from 'react';
import ReactDOM from 'react-dom';

export class InfiniteScrollseProps {

    /** 滚动到底部时事件 */
    loadMore: () => void;

    /** 容器dom搜索字符串默认  .ant-table-body */
    target?: string;

    /** 是否继续触发 loadMore 事件 */
    hasMore: boolean;
}

export class InfiniteScrollseState {

}

/** 滚动条管理组件 */
export default class InfiniteScroll extends React.Component<InfiniteScrollseProps, InfiniteScrollseState> {

    state = new InfiniteScrollseState();

    /** 容器dom */
    private container: Element;

    constructor(props: any) {
        super(props);
    }

    componentDidMount() {
        this.updateContainer();
    }

    componentDidUpdate() {
        this.updateContainer();
    }

    render() {
        return this.props.children;
    }

    /** 滚到顶部 */
    public toTop = () => {
        if (!this.container) {
            return;
        }

        const target: any = this.container.querySelector(this.target);
        if (!target) {
            return;
        }

        target.scrollTop = 0;
    }

    /** 清理dom */
    private clearContainer = () => {
        if (!this.container) {
            return;
        }

        const target: any = this.container.querySelector(this.target);
        if (!target) {
            return;
        }

        target.onscroll = null;
    }

    /** 更新dom */
    private updateContainer = () => {
        this.clearContainer();
        this.container = ReactDOM.findDOMNode(this) as Element;
        const target: any = this.container.querySelector(this.target);
        if (!target) {
            return;
        }
        target.onscroll = this.onScrollHandler;
    }

    /** 滚动条滚动事件 */
    private onScrollHandler = () => {
        if (this.isBottom) {
            if (this.props.hasMore && this.props.loadMore) {
                this.props.loadMore();
            }
        }
    }

    /** 是否在底部 */
    private get isBottom(): boolean {
        if (!this.container) {
            return false;
        }

        const target: any = this.container.querySelector(this.target);
        if (!target) {
            return false;
        }

        // 容器没有高度时候不会触发事件
        if(target.scrollTop + target.clientHeight<=0){
            return false;
        }

        // 容器滚动是否到底
        if (target.scrollTop + target.clientHeight >= target.scrollHeight-5) {
            return true;
        } else {
            return false;
        }
    }

    /** 容器dom搜索字符串 */
    private get target(): string {
        return this.props.target || '.ant-table-body';
    }
}


// WEBPACK FOOTER //
// ./src/node_modules/kts-scaffold-framework/component/InfiniteScroll/index.tsx